import React from "react";
import pres1 from "../../assets/images/pres1.png";
import pres2 from "../../assets/images/pres2.png";
import pres3 from "../../assets/images/pres3.png";
import pres4 from "../../assets/images/pres4.png";
import pres5 from "../../assets/images/pres5.png";
import pres6 from "../../assets/images/pres6.png";
import { FlechCercle } from "../../assets/icons/FlechCercle";
import "./index.scss"; // Assurez-vous que le chemin est correct
export const ServicesListe = () => {
  const prestations = [
    {
      image: pres1,
      title: "Isolation thermique par l’extérieur (ITE)",
      description: "pour réduire vos déperditions et vos factures.",
      linkText: "/ITE",
      text: "Améliorez votre DPE et bénéficiez d’aides financières importantes.",
    },
    {
      image: pres2,
      title: "Isolation intérieure (ITI)",
      description: " idéale pour les appartements ou les murs mitoyens.",
      linkText: "/ITI",
      text: "Idéal pour les logements occupés ou les zones soumises à des contraintes urbanistiques.",
    },
    {
      image: pres3,
      title: "Isolation de toiture",
      description: "premier poste de perte de chaleur.",
      linkText: "/toiture",
      text: "Travaux rentables dès la première année.",
    },
    {
      image: pres4,
      title: "Ravalement de façade",
      description:
        "à la chaux ou anti-fissures, pour embellir et protéger votre bien.",
      linkText: "/ravalement-façade",
      text: "Enduit à la chaux, traitement anti-fissures, finitions personnalisées.",
    },
    {
      image: pres5,
      title: "Rénovation globale pour investisseurs",
      description:
        "Un service clé en main pour optimiser la valeur de vos biens à rénover.",
      linkText: "/renovation-investisseurs",
      text: "Pour une vente rapide ou une mise en location immédiate.",
    },
    {
      image: pres6,
      title: "Aides & accompagnement administratif",
      description:
        "On vous guide dans toutes les démarches pour obtenir MaPrimeRénov’, CEE, TVA réduite, etc.",
      linkText: "/accompagnement-administratif",
      text: "Ne laissez pas passer vos subventions !",
    },
  ];
  return (
    <div className="servicesList pt-0 pt-md-5">
      <div className="row ms-0 justify-content-center  g-md-5 g-3 w-100 align-items-center mb-5 mt-5">
        {prestations.map((prestation, index) => (
          <div className="col-xxl-3 col-lg-4 col-md-6 col-12  mx-auto ">
            <div className="service-card" key={index}>
              <img
                src={prestation.image}
                className="card-img-top"
                alt={prestation.title}
              />
              <div className="card-body">
                <h5
                  className="card-title"
                  dangerouslySetInnerHTML={{ __html: prestation.title }}
                />
                <p className="card-text">{prestation.description}</p>

                {/* Lien toujours en bas */}
                <a
                  href={prestation.linkText}
                  className="service-link d-flex justify-content-between align-items-center">
                  {prestation.text}
                  <div>
                    <FlechCercle />
                  </div>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
